import { FC } from "react"
import { Dayjs } from "dayjs"
import DatePicker from "@/components/shared/DatePicker"
import { Icon, IconColor } from "@/components/shared/Icon"

interface LogPanelHeaderProps {
   isExpanded: boolean
   count: number
   title: string
   name: string
   selectedDate: Dayjs
   timezone: string
   onDateChange: (newDate: Dayjs | null) => void
   onExpand?: () => void
   onClose: () => void
}

const LogPanelHeader: FC<LogPanelHeaderProps> = ({
   isExpanded,
   count,
   name,
   title,
   selectedDate,
   timezone,
   onDateChange,
   onExpand,
   onClose,
}) => {
   return (
      <div className="log-panel__header">
         <span className="log-panel__title">
            <span>{title}</span>
            {isExpanded ? (
               <>: {name}</>
            ) : (
               <span className="log-panel__total-log">{count}</span>
            )}
         </span>
         <span className="log-panel__icons">
            {isExpanded ? (
               <>
                  <span>
                     <DatePicker
                        selectedDate={selectedDate}
                        timezone={timezone}
                        onDateChange={onDateChange}
                     />
                  </span>
                  <Icon
                     name="cross"
                     size="16"
                     color={IconColor.HONOLULU_BLUE}
                     onClick={onClose}
                  />
               </>
            ) : onExpand ? (
               <Icon
                  name="visual"
                  size="16"
                  color={IconColor.HONOLULU_BLUE}
                  onClick={onExpand}
               />
            ) : null}
         </span>
      </div>
   )
}

export default LogPanelHeader
